import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { version } from './values';

export { useTranslation, Trans } from 'react-i18next';

export type { UseTranslationOptions, UseTranslationResponse } from 'react-i18next';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    lng: 'en',
    fallbackLng: 'en',

    interpolation: {
      escapeValue: false // react already safes from xss
    },

    keySeparator: '.',
    contextSeparator: '/',
    pluralSeparator: '/',

    // If we are running locally, don't cache the translation file
    // If running in prod, use the version number to cache-bust
    backend: {
      loadPath: `/locales/{{lng}}/{{ns}}.json`,
      queryStringParams: version ? { v: version } : undefined,
      requestOptions: {
        cache: version ? 'default' : 'no-store'
      }
    }
  });

export default i18n;
